/* eslint-disable */
// /src/pages/MyInfoPage.jsx
import React, { useEffect, useMemo, useState } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { useNavigate } from "react-router-dom";
// BrandHeader는 제거 (요청)
import { useMember } from "../context/MemberContext";
import bearImg from "../assets/images/character_bear.png";
import { clearAll } from "../services/storage";
import FooterCompanyInfo from "components/FooterCompanyInfo";
import { useAppConfig } from "../context/AppConfigContext";
import { db } from "../services/firebase";
import {
  collection,
  deleteDoc,
  getDocs,
  limit,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { useDriverStatusContext } from "context/DriverStatusContext";

// ✅ 포인트 서비스(페이지에서 직접 DB 접근 X가 원칙이지만, 기존 파일 구조 유지 + 포인트는 서비스로만)
import { fetchMemberPointsBalance } from "../services/pointsService";

/* ===== 바코드 전용 폰트 글로벌 주입 ===== */
const GlobalBarcodeFont = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Libre+Barcode+39&display=swap');
`;

/* ===== 세션 유틸 ===== */
const getSessionSafe = () => {
  if (typeof window === "undefined") return null;
  try {
    return JSON.parse(window.localStorage.getItem("dhm.session") || "null");
  } catch {
    return null;
  }
};

/* ===== 세션/스토리지 완전 삭제 유틸 ===== */
function hardClearSession() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem("dhm.session");
    window.localStorage.removeItem("dhm.boundName");
    window.sessionStorage.clear();
  } catch (e) {
    console.error("[logout] failed to clear web session", e);
  }
}

/* 공통 레이아웃 */
const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #d7e8ff 0%, #eaf3ff 100%);
  display: flex;
  flex-direction: column;
`;
const Sheet = styled.div`
  background: #f7faff;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
`;
const Body = styled.div`
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  overflow-y: auto;
  max-width: 880px;
  width: 100%;
  margin: 0 auto;
`;

/* 상단 헤더 이미지 */
const HeaderSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 4px;
  margin-bottom: 4px;
`;
const HeaderImg = styled.img`
  display: block;
  height: auto;
`;

const Card = styled.section`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.06);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
  &:last-child {
    border-bottom: none;
  }
`;
const SmallBtn = styled.button`
  padding: 6px 12px;
  border-radius: 8px;
  border: 1px solid #ddd;
  background: #fff;
  font-size: 13px;
  cursor: pointer;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  &:active {
    transform: translateY(1px);
  }
`;
const DangerBtn = styled.button`
  width: 100%;
  height: 48px;
  border: 0;
  border-radius: 12px;
  background: ${(p) => p.$bg || "#d9a679"};
  color: ${(p) => p.$color || "#ffffff"};
  font-size: 16px;
  cursor: pointer;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  &:active {
    transform: translateY(1px);
  }
`;
const BottomPad = styled.div`
  height: max(24px, env(safe-area-inset-bottom));
`;

/* ✅ 포인트 버튼(이름 라인 우측) */
const NameTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;
const NameLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;
const PointsBtn = styled.button`
  height: 34px;
  padding: 0 12px;
  border-radius: 999px;
  border: 1px solid rgba(17, 24, 39, 0.12);
  background: #ffffff;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #111827;
  font-size: 13px;
  white-space: nowrap;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  &:active {
    transform: translateY(1px);
  }
`;
const PointsPill = styled.span`
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 999px;
  background: #111827;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
`;

/* 미니 멤버십 카드 */
const MiniCard = styled.button`
  margin-top: 8px;
  width: 100%;
  height: 130px;
  border: 0;
  border-radius: 16px;
  display: grid;
  grid-template-columns: 1fr 110px;
  align-items: center;
  gap: 12px;
  padding: 14px;
  background: ${(p) => p.$bg || "#2cb3f0"};
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  text-align: left;
  color: ${(p) => p.$color || "#fff"};
  opacity: ${(p) => (p.$disabled ? 0.6 : 1)};
`;

const MiniTitle = styled.div`
  font-size: 14px;
`;
const MiniNameRow = styled.div`
  font-size: 16px;
  margin-top: 6px;
`;
const MiniId = styled.div`
  margin-top: 6px;
  font-size: 13px;
  letter-spacing: 1px;
  opacity: 0.95;
`;
const MiniFigure = styled.div`
  height: 100%;
  display: grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  overflow: hidden;
  img {
    width: 70%;
    height: auto;
    object-fit: contain;
  }
`;

/* 대시·배지 */
const Badges = styled.div`
  display: flex;
  gap: 2px;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar { display: none; }
`;
const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 6px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
  white-space: nowrap;
  flex-shrink: 0;
`;
const Metric = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  align-items: center;
  font-size: 14px;
  padding: 8px 0;
  border-bottom: 1px dashed #e5e7eb;
  &:last-child {
    border-bottom: none;
  }
`;

/* 오버레이 (공용) */
const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.75);
  display: grid;
  place-items: center;
  z-index: 50;
`;

/* 멤버십 카드 프레임 */
const CardFace = styled.div`
  border-radius: 28px;
  position: relative;
  overflow: hidden;
  background: ${(p) => p.$bg};
  padding: 18px 18px 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-height: 420px;
  width: min(420px, 94vw);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.4);
`;

/* 상단 타이틀 + 닫기 */
const CardTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const CardHeader = styled.div`
  font-size: 16px;
  font-weight: 800;
  color: #111827;
`;
const CardSubtitle = styled.div`
  margin-top: 4px;
  font-size: 13px;
  color: #111827;
`;
const CloseBtn = styled.button`
  border: 0;
  background: transparent;
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  color: #111827;
  &:active {
    transform: translateY(1px);
  }
`;

/* 이름 + 번호 행 */
const CardNameRow = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
`;
const NameLabel = styled.div`
  font-size: 20px;
  font-weight: 800;
  color: #111827;
`;
const NumberPill = styled.div`
  flex: 1;
  min-height: 38px;
  border-radius: 999px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.14em;
  color: #111827;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
`;

/* 바코드 영역 */
const BarcodeBox = styled.div`
  margin-top: 18px;
  width: 100%;
  border-radius: 18px;
  background: #ffffff;
  padding: 14px 10px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden; /* 팝업 밖으로 튀어나가지 않게 */
`;

const BarcodeInner = styled.div`
  font-family: "Libre Barcode 39", monospace;
  font-style: normal;
  font-weight: 400;
  font-size: 52px;
  line-height: 1;
  color: #000;
  transform: scaleX(0.72);
  white-space: nowrap;
`;

const BarcodeNumber = styled.div`
  margin-top: 10px;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.12em;
  color: #111827;
`;

const BarcodeHint = styled.div`
  margin-top: 10px;
  font-size: 12px;
  color: #111827;
  text-align: center;
  line-height: 1.5;
`;

/* 마스코트 영역 */
const MascotArea = styled.div`
  flex: 1;
  margin-top: 26px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;
const MascotImg = styled.img`
  height: 150px;
  width: auto;
  object-fit: contain;
  filter: drop-shadow(0 10px 16px rgba(0, 0, 0, 0.35));
`;

/* 차량번호 변경 / 공용 모달 박스 */
const CarModal = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 20px 18px 18px;
  width: min(360px, 92vw);
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.45);
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const CarModalTitle = styled.h2`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
`;
const CarModalDesc = styled.p`
  margin: 0;
  font-size: 13px;
  color: #64748b;
`;
const CarModalInput = styled.input`
  width: 100%;
  height: 44px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  padding: 0 12px;
  font-size: 14px;
  outline: none;
  &:focus {
    border-color: #4f46e5;
    box-shadow: 0 0 0 1px rgba(79, 70, 229, 0.15);
  }
`;
const CarModalActions = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
const CarCancelBtn = styled.button`
  min-width: 80px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  font-size: 14px;
  cursor: pointer;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  &:active {
    transform: translateY(1px);
  }
`;
const CarSaveBtn = styled.button`
  min-width: 120px;
  height: 40px;
  border-radius: 10px;
  border: 0;
  background: ${(p) => p.$bg || "#111827"};
  color: ${(p) => p.$color || "#ffffff"};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  &:active {
    transform: translateY(1px);
  }
`;

/* 회원탈퇴 모달 전용 */
const WithdrawBarWrap = styled.div`
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: #e5e7eb;
  overflow: hidden;
  margin-top: 10px;
`;
const WithdrawBarInner = styled.div`
  height: 100%;
  border-radius: 999px;
  background: #dc2626;
  width: ${(p) => `${p.$percent || 0}%`};
  transition: width 0.12s linear;
`;

const PwField = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-size: 13px;
    color: #4b5563;
  }
`;

const PwInputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const PwToggleBtn = styled.button`
  min-width: 60px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  font-size: 12px;
  cursor: pointer;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  &:active {
    transform: translateY(1px);
  }
`;

/* 멤버십 색상 매핑 */
const COLORS = {
  guest: "#EDEDED",
  orange: "#FF5A00",
  purple: "#A64AC9",
  emerald: "#2CB3F0",
};

function maskPhone(p) {
  if (!p) return "";
  const s = p.replace(/\D/g, "");
  return `010-****-${s.slice(-4)}`;
}

function makeDisplayId(phoneE164 = "") {
  const digits = (phoneE164.match(/\d/g) || []).join("").slice(-12).padStart(12, "0");
  const prefix = "91";
  const checksum = (
    digits.split("").reduce((a, b) => a + Number(b), 0) % 97
  )
    .toString()
    .padStart(2, "0");
  const full = prefix + digits + checksum;
  return full.replace(/(\d{4})(?=\d)/g, "$1-");
}

function formatKRW(v) {
  if (v == null) return "0원";
  const num = Number(String(v).replace(/,/g, "").trim());
  if (Number.isNaN(num)) return "0원";
  const int = Math.trunc(num);
  return `${int.toLocaleString("ko-KR")}원`;
}

function mapGradeToTier(grade) {
  switch (grade) {
    case "orange":
      return "오렌지";
    case "purple":
      return "퍼플";
    case "emerald":
      return "에메랄드";
    case "guest":
    default:
      return "게스트";
  }
}

function mapMemberType(_status, memberType) {
  switch (memberType) {
    case "personal":
      return "개인택시 기사";
    case "corporate":
      return "법인택시 소속 기사";
    case "general":
      return "일반 회원 (택시 기사 아님)";
    default:
      return "미확인";
  }
}

function safeInt(v) {
  const n = Number(v);
  if (!isFinite(n) || Number.isNaN(n)) return 0;
  return Math.trunc(n);
}

function formatPoints(v) {
  const n = safeInt(v);
  return n.toLocaleString("ko-KR");
}

export default function MyInfoPage() {
  const navigate = useNavigate();

  const m = (() => {
    try {
      return useMember?.();
    } catch {
      return null;
    }
  })();

  const [loggingOut, setLoggingOut] = useState(false);
  const [open, setOpen] = useState(false); // 멤버십 카드 확대
  const [cardTime, setCardTime] = useState("");
  const [carModalOpen, setCarModalOpen] = useState(false);
  const [carNumberInput, setCarNumberInput] = useState("");
  const [carSaving, setCarSaving] = useState(false);

  // ✅ 포인트 상태(없으면 0으로)
  const [pointsLoading, setPointsLoading] = useState(false);
  const [pointsBalance, setPointsBalance] = useState(0);
  const [memberDocId, setMemberDocId] = useState("");

  // 비밀번호 변경 상태
  const [pwModalOpen, setPwModalOpen] = useState(false);
  const [pwSaving, setPwSaving] = useState(false);
  const [pwCurrent, setPwCurrent] = useState("");
  const [pwNew, setPwNew] = useState("");
  const [pwNewConfirm, setPwNewConfirm] = useState("");
  const [showPwCurrent, setShowPwCurrent] = useState(false);
  const [showPwNew, setShowPwNew] = useState(false);
  const [showPwNewConfirm, setShowPwNewConfirm] = useState(false);

  // 회원탈퇴 모달 상태
  const [withdrawModalOpen, setWithdrawModalOpen] = useState(false);
  const [withdrawing, setWithdrawing] = useState(false);
  const [withdrawProgress, setWithdrawProgress] = useState(0);
  const [withdrawMessage, setWithdrawMessage] = useState("회원탈퇴중입니다...");
  const [withdrawError, setWithdrawError] = useState("");

  const {
    loading,
    error,
    franchisename,
    memberType,
    totalFare,
    lastSettlementFare,
    lastSettlementMonth,
    grade,
    membershipBarcode,
    status,
    phoneE164: dsPhoneE164,
    name: dsName,
    carNumber: dsCarNumber,
    username,
  } = useDriverStatusContext();

  const contextName = m?.member?.name;
  const contextPhone = m?.member?.phoneE164;

  const session = getSessionSafe();
  const sessionName = session?.name || null;
  const sessionPhone = session?.phoneE164 || session?.phone || null;

  const baseName = dsName || contextName || sessionName || "";
  const basePhoneE164 = dsPhoneE164 || contextPhone || sessionPhone || "";

  const [profileReady, setProfileReady] = useState(false);

  useEffect(() => {
    if (!loading && !profileReady) {
      setProfileReady(true);
    }
  }, [loading, profileReady]);

  const displayName = !profileReady
    ? baseName || "정보 불러오는 중..."
    : baseName || "이름 확인 안됨";

  const displayPhoneMasked = !profileReady
    ? basePhoneE164
      ? maskPhone(basePhoneE164)
      : ""
    : basePhoneE164
      ? maskPhone(basePhoneE164)
      : "전화번호 확인 안됨";

  // 현재시간 (초단위) — 페이지 진입 시 세팅 + 5분마다 갱신
  const formatNow = () => {
    const d = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };
  const [currentTime, setCurrentTime] = useState(formatNow);
  useEffect(() => {
    setCurrentTime(formatNow());
    const id = setInterval(() => setCurrentTime(formatNow()), 5 * 60 * 1000);
    return () => clearInterval(id);
  }, []);

  // 멤버십 카드 열릴 때 시간 갱신 + 5분 간격
  useEffect(() => {
    if (!open) return;
    setCardTime(formatNow());
    const id = setInterval(() => setCardTime(formatNow()), 5 * 60 * 1000);
    return () => clearInterval(id);
  }, [open]);

  const tierText = mapGradeToTier(grade);
  const memberTypeText = mapMemberType(status, memberType);
  const membershipBg = COLORS[grade] || COLORS.guest;
  const membershipTextColor = grade === "guest" ? "#111827" : "#ffffff";

  const { config, loading: configLoading } = useAppConfig();
  const detail = config?.detailScreens || {};
  const myInfoCfg = detail.myInfo || {};
  const headerImg = myInfoCfg.headerImg || "";

  const logoutBg = myInfoCfg.logoutBgColor || "#db6edd";
  const logoutTextColor = myInfoCfg.logoutTextColor || "#ffffff";
  const withdrawBg = myInfoCfg.withdrawBgColor || "#d9a679";
  const withdrawTextColor = myInfoCfg.withdrawTextColor || "#ffffff";

  const displayId = useMemo(() => {
    const raw = membershipBarcode || "";
    if (raw && /^\d{12}$/.test(raw)) {
      return raw.replace(/(\d{4})(?=\d)/g, "$1-");
    }
    if (!basePhoneE164) return "";
    return makeDisplayId(basePhoneE164);
  }, [membershipBarcode, basePhoneE164]);

  const barcodeValue = useMemo(
    () => (displayId ? displayId.replace(/\D/g, "") : ""),
    [displayId]
  );

  // ✅ 내 members 문서 id 찾고 → pointsService로 잔액 로드
  const refreshMyPoints = async () => {
    try {
      if (!username) {
        setMemberDocId("");
        setPointsBalance(0);
        return;
      }
      setPointsLoading(true);

      // members/{docId}가 필요(현재 프로젝트는 username으로 members 조회를 이미 쓰고 있으니 동일 패턴 유지)
      const col = collection(db, "members");
      const q = query(col, where("username", "==", username), limit(1));
      const snap = await getDocs(q);

      if (snap.empty) {
        setMemberDocId("");
        setPointsBalance(0);
        return;
      }

      const docId = snap.docs[0].id;
      setMemberDocId(docId);

      const res = await fetchMemberPointsBalance({ memberId: docId });
      const bal = safeInt(res?.balance);
      setPointsBalance(bal);
    } catch (e) {
      console.error("[MyInfo] refreshMyPoints error", e);
      setPointsBalance(0);
    } finally {
      setPointsLoading(false);
    }
  };

  useEffect(() => {
    if (!profileReady) return;
    refreshMyPoints();
  }, [profileReady, username]);

  const goMyPointsHistory = () => {
    // ✅ 포인트 사용 내역 페이지(라우팅은 형이 이미 만들어둔 전제)
    // - 페이지에서 state로 memberId 받게 해두면 깔끔
    if (!memberDocId) {
      alert("포인트 정보를 불러올 수 없습니다. 잠시 후 다시 시도해 주세요.");
      return;
    }
    navigate("/points/history", {
      state: {
        memberId: memberDocId,
        name: baseName || "",
        phoneE164: basePhoneE164 || "",
      },
    });
  };

  const logout = async () => {
    try {
      setLoggingOut(true);
      hardClearSession();
      clearAll();
      if (typeof window !== "undefined") {
        window.location.href = "/auth";
        return;
      }
    } catch (e) {
      console.error(e);
      alert("로그아웃 중 문제가 발생했습니다.");
    } finally {
      setLoggingOut(false);
    }
  };

  const openCarModal = () => {
    setCarNumberInput(dsCarNumber || "");
    setCarModalOpen(true);
  };

  const saveCarNumberAndLogout = async () => {
    const trimmed = carNumberInput.trim();
    if (!trimmed) {
      alert("차량번호를 입력해 주세요.");
      return;
    }
    if (!username) {
      alert("사용자 정보를 찾을 수 없습니다. 다시 로그인 후 시도해 주세요.");
      return;
    }

    try {
      setCarSaving(true);

      const col = collection(db, "members");
      const q = query(col, where("username", "==", username), limit(1));
      const snap = await getDocs(q);
      if (snap.empty) {
        alert("회원 정보를 찾을 수 없습니다.");
        setCarSaving(false);
        return;
      }

      const docRef = snap.docs[0].ref;
      await updateDoc(docRef, { carNumber: trimmed });

      alert("차량번호가 변경되었습니다. 다시 로그인해 주세요.");
      setCarSaving(false);
      setCarModalOpen(false);

      await logout();
    } catch (e) {
      console.error(e);
      alert("차량번호 변경 중 오류가 발생했습니다.");
      setCarSaving(false);
    }
  };

  const openPwModal = () => {
    setPwCurrent("");
    setPwNew("");
    setPwNewConfirm("");
    setShowPwCurrent(false);
    setShowPwNew(false);
    setShowPwNewConfirm(false);
    setPwModalOpen(true);
  };

  const savePasswordAndLogout = async () => {
    const current = pwCurrent.trim();
    const next = pwNew.trim();
    const next2 = pwNewConfirm.trim();

    if (!current || !next || !next2) {
      alert("현재 비밀번호와 새 비밀번호를 모두 입력해 주세요.");
      return;
    }
    if (next !== next2) {
      alert("새 비밀번호와 확인이 일치하지 않습니다.");
      return;
    }
    if (next.length < 6) {
      alert("새 비밀번호는 6자 이상이어야 합니다.");
      return;
    }

    try {
      setPwSaving(true);

      if (!username) {
        alert("사용자 정보를 찾을 수 없습니다. 다시 로그인 후 시도해 주세요.");
        setPwSaving(false);
        return;
      }

      const col = collection(db, "members");
      const q = query(col, where("username", "==", username), limit(1));
      const snap = await getDocs(q);

      if (snap.empty) {
        alert("회원 정보를 찾을 수 없습니다. 다시 로그인 후 시도해 주세요.");
        setPwSaving(false);
        return;
      }

      const docSnap = snap.docs[0];
      const data = docSnap.data() || {};
      const storedPw = (data.password || "").trim();

      if (storedPw !== current) {
        alert("현재 비밀번호가 올바르지 않습니다.");
        setPwSaving(false);
        return;
      }

      await updateDoc(docSnap.ref, { password: next });

      alert("비밀번호가 변경되었습니다. 다시 로그인해 주세요.");
      setPwSaving(false);
      setPwModalOpen(false);

      await logout();
    } catch (e) {
      console.error("[MyInfo] savePasswordAndLogout error", e);
      alert("비밀번호 변경 중 오류가 발생했습니다.");
      setPwSaving(false);
    }
  };

  const isCorporateMember =
    status === "member" && memberType === "corporate" && franchisename;

  const lastMonthSales =
    lastSettlementFare != null ? lastSettlementFare : totalFare;

  const settlementMonthLabel = useMemo(() => {
    if (!lastSettlementMonth) return "마지막 정산 월 매출";

    const raw = String(lastSettlementMonth).trim();

    if (/^\d{4}-\d{1,2}/.test(raw)) {
      const parts = raw.split("-");
      const monthNum = Number(parts[1]);
      if (!monthNum || Number.isNaN(monthNum)) {
        return `정산 매출 (${raw})`;
      }
      return `${monthNum}월 매출`;
    }

    if (/^\d{6}$/.test(raw)) {
      const monthNum = Number(raw.slice(4, 6));
      if (!monthNum || Number.isNaN(monthNum)) {
        return `정산 매출 (${raw})`;
      }
      return `${monthNum}월 매출`;
    }

    return `정산 매출 (${raw})`;
  }, [lastSettlementMonth]);

  const handleWithdrawClick = () => {
    if (withdrawing) return;

    const confirmed = window.confirm(
      "정말로 탈퇴하시겠습니까?\n탈퇴 후에는 계정과 관련 데이터가 삭제되며, 복구가 불가합니다."
    );
    if (!confirmed) return;

    setWithdrawError("");
    setWithdrawMessage("회원탈퇴중입니다...");
    setWithdrawProgress(0);
    setWithdrawModalOpen(true);
    startWithdrawFlow();
  };

  const startWithdrawFlow = async () => {
    if (withdrawing) return;
    setWithdrawing(true);
    try {
      if (!username) {
        throw new Error("회원 정보를 찾을 수 없습니다. 다시 로그인 후 시도해 주세요.");
      }

      const col = collection(db, "members");
      const q = query(col, where("username", "==", username), limit(1));
      const snap = await getDocs(q);
      if (!snap.empty) {
        const ref = snap.docs[0].ref;
        await deleteDoc(ref);
      }

      const steps = 50;
      for (let i = 1; i <= steps; i += 1) {
        setWithdrawProgress((i / steps) * 100);
        // eslint-disable-next-line no-await-in-loop
        await new Promise((res) => setTimeout(res, 100));
      }

      setWithdrawProgress(100);
      setWithdrawMessage("삭제 되었습니다.");
      setWithdrawError("");

      setTimeout(() => {
        try {
          hardClearSession();
          clearAll();
        } catch (e) {
          console.error(e);
        }
        if (typeof window !== "undefined") {
          window.location.href = "/auth";
        }
      }, 800);
    } catch (e) {
      console.error("[withdraw] error", e);
      setWithdrawError(
        e?.message || "회원탈퇴 처리 중 오류가 발생했습니다. 다시 시도해 주세요."
      );
      setWithdrawMessage("회원탈퇴 중 오류가 발생했습니다.");
    } finally {
      setWithdrawing(false);
    }
  };

  return (
    <Wrap>
      <GlobalBarcodeFont />
      <Sheet>
        <Body>
          {!configLoading && headerImg && (
            <HeaderSection>
              <HeaderImg src={headerImg} alt="내정보 헤더" />
            </HeaderSection>
          )}

          {/* 기본 정보 + 멤버십 카드 */}
          <Card>
            <NameTopRow>
              <NameLeft>
                <div style={{ fontSize: 16, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {displayName}
                </div>
                <div style={{ fontSize: 14, color: "#555" }}>
                  {displayPhoneMasked}
                </div>
              </NameLeft>

              {/* ✅ 이름 라인 우측 포인트 버튼 */}
              <PointsBtn
                type="button"
                onClick={goMyPointsHistory}
                disabled={pointsLoading || loggingOut || !memberDocId}
                title="포인트 사용 내역 보기"
              >
                포인트
                <PointsPill>
                  {pointsLoading ? "..." : `${formatPoints(pointsBalance)}P`}
                </PointsPill>
              </PointsBtn>
            </NameTopRow>

            <div
              style={{
                marginTop: 8,
                display: "flex",
                gap: 8,
              }}
            >
              <SmallBtn
                type="button"
                onClick={openCarModal}
                disabled={loading || loggingOut}
              >
                차량번호 변경
              </SmallBtn>
              <SmallBtn
                type="button"
                onClick={openPwModal}
                disabled={loading || loggingOut}
              >
                비밀번호 변경
              </SmallBtn>

            </div>

            <div style={{ marginTop: 8 }}>
              {loading ? (
                <div style={{ color: "#64748b", fontSize: 13 }}>
                  매출/등급 불러오는 중…
                </div>
              ) : error ? (
                <div style={{ color: "#b91c1c", fontSize: 13 }}>{error}</div>
              ) : (
                <div style={{ display: "grid", gap: 6 }}>
                  {isCorporateMember && (
                    <Metric>
                      <span>가맹점(운수사)</span>
                      <strong>{franchisename}</strong>
                    </Metric>
                  )}

                  <Metric>
                    <span>회원 유형</span>
                    <strong>{memberTypeText}</strong>
                  </Metric>

                  <Metric>
                    <span>{settlementMonthLabel}</span>
                    <strong>
                      {isCorporateMember
                        ? "금액은 확인할수 없습니다"
                        : formatKRW(lastMonthSales)}
                    </strong>
                  </Metric>

                  <Metric>
                    <span>등급</span>
                    <strong>{tierText}</strong>
                  </Metric>

                  {lastSettlementMonth && (
                    <div
                      style={{
                        gridColumn: "1 / -1",
                        fontSize: 12,
                        color: "#64748b",
                        textAlign: "right",
                      }}
                    >
                      기준 정산월: {lastSettlementMonth}
                    </div>
                  )}
                </div>
              )}
            </div>

            {!loading && !error && (
              <Badges style={{ marginTop: 8, alignItems: "center" }}>
                <Badge>등급: {tierText}</Badge>
                <Badge>{memberTypeText}</Badge>
                {isCorporateMember && <Badge>{franchisename}</Badge>}
                <Badge style={{ marginLeft: "auto" }}>{currentTime}</Badge>
              </Badges>
            )}

            <MiniCard
              $bg={membershipBg}
              $color={membershipTextColor}
              $disabled={!baseName && !basePhoneE164}
              onClick={() => {
                if (baseName || basePhoneE164) setOpen(true);
              }}
              aria-label="멤버십 카드 열기"
            >
              <div>
                <MiniTitle>Membership</MiniTitle>
                <MiniNameRow>
                  {baseName ? `${baseName} 님` : "이름 확인 안됨"}
                </MiniNameRow>
                <MiniId>
                  {displayId || (basePhoneE164 ? "ID 생성중" : "ID 미발급")}
                </MiniId>
              </div>
              <MiniFigure>
                <img src={bearImg} alt="membership mascot" />
              </MiniFigure>
            </MiniCard>

          </Card>

          {/* 기타 링크 */}
          <Card>
            <Row
              onClick={() => navigate("/orders")}
              style={{ cursor: "pointer" }}
            >
              <span>주문내역</span>
              <span>›</span>
            </Row>

            <Row
              onClick={() => navigate("/notice")}
              style={{ cursor: "pointer" }}
            >
              <span>공지사항</span>
              <span>›</span>
            </Row>
            <Row
              onClick={() => navigate("/terms")}
              style={{ cursor: "pointer" }}
            >
              <span>이용약관</span>
              <span>›</span>
            </Row>
            <Row
              onClick={() => navigate("/privacy")}
              style={{ cursor: "pointer" }}
            >
              <span>개인정보 처리방침</span>
              <span>›</span>
            </Row>
            <Row
              onClick={() => navigate("/my/account")}
              style={{ cursor: "pointer" }}
            >
              <span>My Account</span>
              <span>›</span>
            </Row>
            <Row>
              <span>앱 버전</span>
              <span>v1.0.0</span>
            </Row>
          </Card>


          <BottomPad />
        </Body>
      </Sheet>

      {/* 멤버십 카드 확대 */}
      {open && (
        <Backdrop
          onClick={() => setOpen(false)}
          role="dialog"
          aria-modal="true"
        >
          <CardFace
            $bg={membershipBg}
            onClick={(e) => e.stopPropagation()}
          >
            <CardTopRow>
              <div>
                <CardHeader>멤버십 바코드</CardHeader>
                <CardSubtitle>
                  Membership Card • {tierText}
                </CardSubtitle>
                <div style={{ fontSize: 11, color: grade === "guest" ? "#6b7280" : "rgba(255,255,255,0.7)", marginTop: 4 }}>{cardTime}</div>
              </div>
              <CloseBtn
                type="button"
                aria-label="닫기"
                onClick={() => setOpen(false)}
              >
                ✕
              </CloseBtn>
            </CardTopRow>

            <CardNameRow>
              <NameLabel>{displayName}</NameLabel>
              <NumberPill>
                {displayId || "ID 미발급"}
              </NumberPill>
            </CardNameRow>

            <BarcodeBox>
              {barcodeValue && (
                <>
                  <BarcodeInner>{`*${barcodeValue}*`}</BarcodeInner>
                  <BarcodeNumber>{displayId}</BarcodeNumber>
                </>
              )}
            </BarcodeBox>

            <BarcodeHint>
              화면 밝기를 최대로 올리고,
              <br />
              스캐너에 가로 방향으로 바코드를 보여 주세요.
            </BarcodeHint>

            <MascotArea>
              <MascotImg src={bearImg} alt="membership mascot" />
            </MascotArea>
          </CardFace>
        </Backdrop>
      )}

      {/* 차량번호 변경 / 비밀번호 변경 / 회원탈퇴 모달 그대로 유지 */}
      {carModalOpen && (
        <Backdrop
          onClick={() => (!carSaving ? setCarModalOpen(false) : null)}
          role="dialog"
          aria-modal="true"
        >
          <CarModal onClick={(e) => e.stopPropagation()}>
            <CarModalTitle>차량번호 변경</CarModalTitle>
            <CarModalDesc>
              차량번호를 변경하면 자동 로그아웃됩니다.
              <br />
              예시: 동탄12바1234
            </CarModalDesc>
            <CarModalInput
              value={carNumberInput}
              onChange={(e) => setCarNumberInput(e.target.value)}
              placeholder="예: 동탄12바1234"
              disabled={carSaving}
            />
            <CarModalActions>
              <CarCancelBtn
                type="button"
                onClick={() => setCarModalOpen(false)}
                disabled={carSaving}
              >
                취소
              </CarCancelBtn>
              <CarSaveBtn
                type="button"
                onClick={saveCarNumberAndLogout}
                disabled={carSaving}
                $bg="#676764"
                $color={logoutTextColor}
              >
                {carSaving ? "저장 중..." : "변경 후 로그아웃"}
              </CarSaveBtn>
            </CarModalActions>
          </CarModal>
        </Backdrop>
      )}

      {pwModalOpen && (
        <Backdrop
          onClick={() => (!pwSaving ? setPwModalOpen(false) : null)}
          role="dialog"
          aria-modal="true"
        >
          <CarModal onClick={(e) => e.stopPropagation()}>
            <CarModalTitle>비밀번호 변경</CarModalTitle>
            <CarModalDesc>
              현재 비밀번호와 새 비밀번호를 입력해 주세요.
              <br />
              변경 후에는 자동으로 로그아웃됩니다.
            </CarModalDesc>

            <PwField>
              <label>현재 비밀번호</label>
              <PwInputRow>
                <CarModalInput
                  type={showPwCurrent ? "text" : "password"}
                  value={pwCurrent}
                  onChange={(e) => setPwCurrent(e.target.value)}
                  placeholder="현재 비밀번호"
                  disabled={pwSaving}
                />
                <PwToggleBtn
                  type="button"
                  onClick={() => setShowPwCurrent((v) => !v)}
                  disabled={pwSaving}
                >
                  {showPwCurrent ? "숨기기" : "보기"}
                </PwToggleBtn>
              </PwInputRow>
            </PwField>

            <PwField>
              <label>새 비밀번호</label>
              <PwInputRow>
                <CarModalInput
                  type={showPwNew ? "text" : "password"}
                  value={pwNew}
                  onChange={(e) => setPwNew(e.target.value)}
                  placeholder="새 비밀번호 (6자 이상)"
                  disabled={pwSaving}
                />
                <PwToggleBtn
                  type="button"
                  onClick={() => setShowPwNew((v) => !v)}
                  disabled={pwSaving}
                >
                  {showPwNew ? "숨기기" : "보기"}
                </PwToggleBtn>
              </PwInputRow>
            </PwField>

            <PwField>
              <label>새 비밀번호 확인</label>
              <PwInputRow>
                <CarModalInput
                  type={showPwNewConfirm ? "text" : "password"}
                  value={pwNewConfirm}
                  onChange={(e) => setPwNewConfirm(e.target.value)}
                  placeholder="새 비밀번호 확인"
                  disabled={pwSaving}
                />
                <PwToggleBtn
                  type="button"
                  onClick={() => setShowPwNewConfirm((v) => !v)}
                  disabled={pwSaving}
                >
                  {showPwNewConfirm ? "숨기기" : "보기"}
                </PwToggleBtn>
              </PwInputRow>
            </PwField>

            <CarModalActions>
              <CarCancelBtn
                type="button"
                onClick={() => setPwModalOpen(false)}
                disabled={pwSaving}
              >
                취소
              </CarCancelBtn>
              <CarSaveBtn
                type="button"
                onClick={savePasswordAndLogout}
                disabled={pwSaving}
                $bg="#111827"
              >
                {pwSaving ? "변경 중..." : "비밀번호 변경"}
              </CarSaveBtn>
            </CarModalActions>
          </CarModal>
        </Backdrop>
      )}

      {withdrawModalOpen && (
        <Backdrop
          onClick={() => (!withdrawing ? setWithdrawModalOpen(false) : null)}
          role="dialog"
          aria-modal="true"
        >
          <CarModal onClick={(e) => e.stopPropagation()}>
            <CarModalTitle>회원탈퇴 진행 중</CarModalTitle>
            <CarModalDesc>
              {withdrawMessage}
              <br />
              회원 정보를 안전하게 삭제하고 있습니다.
            </CarModalDesc>

            <WithdrawBarWrap>
              <WithdrawBarInner $percent={withdrawProgress} />
            </WithdrawBarWrap>

            {withdrawError && (
              <div
                style={{
                  marginTop: 10,
                  fontSize: 12,
                  color: "#b91c1c",
                  whiteSpace: "pre-line",
                }}
              >
                {withdrawError}
              </div>
            )}

            <CarModalActions>
              {!withdrawing && (
                <CarCancelBtn
                  type="button"
                  onClick={() => setWithdrawModalOpen(false)}
                >
                  닫기
                </CarCancelBtn>
              )}
            </CarModalActions>
          </CarModal>
        </Backdrop>
      )}

      <FooterCompanyInfo />
    </Wrap>
  );
}
